
var $j = jQuery.noConflict();

$j(document).ready(function() {
    $j("#read-more").on('click', function(event){
        $j("#biography-less").hide();
        $j(".lastfilm").hide();
        $j("#biography-more").show();
        $j("#biography-more").parents(".biographie").removeClass("col-sm-6 col-md-6 col-lg-6").
            addClass("col-sm-12 col-md-12 col-lg-12");
    });

    $j("#read-less").on('click', function(){
        $j("#biography-more").hide();
        $j("#biography-less").show();
        $j(".lastfilm").show();
        $j("#biography-more").parents(".biographie").removeClass("col-sm-12 col-md-12 col-lg-12").
            addClass("col-sm-6 col-md-6 col-lg-6");
    });
});

(function( insertSrcAttrElImg) {
    'use strict';

    document.addEventListener( 'DOMContentLoaded', function() {
        var elImg = document.getElementsByClassName( 'filmography-item-img');
        insertSrcAttrElImg( elImg);
    });

})(insertSrcAttrElImg);
